import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MachineList from "./MachineList";

export default function LicenceCard({ licence, machines, order, onDeactivate }) {
  const [revealed, setRevealed] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [copied, setCopied] = useState(false);
  const { t, i18n } = useTranslation("dashboard");

  const key = licence.licence_key;
  const masked = key.slice(0, 5) + "****-****-" + key.slice(-4);

  const handleCopy = () => {
    navigator.clipboard.writeText(key);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="feature-card rounded-lg p-6">
      <div className="flex flex-wrap items-start justify-between gap-3 mb-4">
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
            <code className="text-white font-mono text-sm break-all">{revealed ? key : masked}</code>
            <button onClick={() => setRevealed(!revealed)} className="text-xs text-[#A1A1AA] hover:text-white">{revealed ? t("licenceCard.hide") : t("licenceCard.show")}</button>
            <button onClick={handleCopy} className="text-xs text-[#FF5500] hover:text-[#FF7733]">{copied ? t("licenceCard.copied") : t("licenceCard.copy")}</button>
          </div>
          <p className="text-xs text-[#A1A1AA] mt-1">{t("licenceCard.purchased", { date: order?.created_at ? new Date(order.created_at).toLocaleDateString(i18n.language) : t("licenceCard.notAvailable") })}</p>
        </div>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <span className={`text-xs px-2 py-1 rounded ${licence.revoked ? "bg-red-500/10 text-red-400" : "bg-green-500/10 text-green-400"}`}>
            {licence.revoked ? t("licenceCard.revoked") : t("licenceCard.active")}
          </span>
          <span className="text-xs text-[#A1A1AA]">{t("licenceCard.machineCount", { used: machines.length, max: licence.max_machines })}</span>
        </div>
      </div>
      <button onClick={() => setExpanded(!expanded)} className="text-xs text-[#A1A1AA] hover:text-white transition-colors">
        {expanded ? t("licenceCard.hideMachines") : t("licenceCard.showMachines")}
      </button>
      {expanded && <MachineList machines={machines} licenceKey={key} onDeactivate={onDeactivate} />}
    </div>
  );
}
